import { MenuItem } from "src/models/layout";

const useAgencyRoutese = (): MenuItem[] => [];
// co the xoa
export default useAgencyRoutese;
